import { getMaintenanceCategoryApi, createMaintenanceCategoryApi, updateMaintenanceCategoryApi, deleteMaintenanceCategoryApi, getMaintenanceCategoryByIdApi } from "../../helpers/backend_helper";

import {
    errorMessages,
    getMaintenanceCategoryList,
    MaintenanceCategoryById,
    MaintenanceCategoryByType,
    hideErrorMessage,
    setLoading

} from "./reducer";


export const getMaintenanceCategory = (currentPage, pageSize, searchText) => async (dispatch) => {
    try {
        dispatch(setLoading({ type: "read", value: true }));
        let response;
        response = await getMaintenanceCategoryApi(currentPage, pageSize, searchText);
        const data = await response;
        dispatch(getMaintenanceCategoryList(data));
        return true;
    } catch (error) {
        const errorMessage = error.response.data.errors;
        dispatch(errorMessages(errorMessage));
        return false;
    } finally {
        dispatch(setLoading({ type: "read", value: false }));
    }
};


export const getMaintenanceCategoryById = (id) => async (dispatch) => {
    try {
        dispatch(setLoading({ type: "getById", value: true }));
        let response;
        response = getMaintenanceCategoryByIdApi(id);
        const data = await response;
        dispatch(MaintenanceCategoryById(data));
        return true;
    } catch (error) {
        const errorMessage = error.response.data.errors;
        dispatch(errorMessages(errorMessage));
        return false;
    } finally {
        dispatch(setLoading({ type: "getById", value: false }));
    }
}

export const createMaintenanceCategory = (data) => async (dispatch) => {
    try {
        dispatch(setLoading({ type: "create", value: true }));
        await createMaintenanceCategoryApi(data);
        return { success: true, message: "Maintenance Category Successfully Created" };
    } catch (error) {
        const errorMessage = error.response?.data?.errors || "Error creating maintenance category";
        return { success: false, message: errorMessage };
    } finally {
        dispatch(setLoading({ type: "create", value: false }));
    }
}


export const updateMaintenanceCategory = (id, data) => async (dispatch) => {
    try {
        dispatch(setLoading({ type: "update", value: true }));
        await updateMaintenanceCategoryApi(id, data);
        return { success: true, message: "Maintenance Category Successfully Updated" }
    } catch (error) {
        const errorMessage = error.response.data.errors;
        return { success: false, message: errorMessage };
    } finally {
        dispatch(setLoading({ type: "update", value: false }));
    }
}


export const deleteMaintenanceCategory = (id) => async (dispatch) => {
    try {
        dispatch(setLoading({ type: "delete", value: true }));
        await deleteMaintenanceCategoryApi(id);
        return { success: true, message: "Maintenance Category successfully deleted" };

    } catch (error) {
        const errorMessage = error.response?.data?.errors || "An error occurred";
        return { success: false, message: errorMessage };
    } finally {
        dispatch(setLoading({ type: "delete", value: false }));
    }
};